import DashboardPreview from "./../dashboard-preview";
import "./dashboard.css";

export function Dashboard() {
  return (
    <section className="r2-dashboard">
      <div className="r2-dashboard__header">
        <p className="r2-dashboard__eyebrow">
          MANAGE RISK YOUR WAY
        </p>

        <h2 className="r2-dashboard__title">
          <span className="r2-dashboard__title-accent">
            Build Custom Trust & Safety Workflows
          </span>
        </h2>
      </div>
      <DashboardPreview />
    </section>
  );
}
